import { useMemo } from 'react';
import { useAuthStore } from '../../auth/model/auth.store';
import { DEFAULT_TIMEZONE } from '../../../shared/lib/constants';
import { todayIso, tomorrowIso } from '../../../shared/lib/datetime';

export interface UserDates {
  today: string;
  tomorrow: string;
  timezone: string;
}

/** Календарные «сегодня» / «завтра» в часовом поясе пользователя. */
export function useUserDates(): UserDates {
  const timezone = useAuthStore((state) => state.user?.timezone ?? DEFAULT_TIMEZONE);
  const today = useMemo(() => todayIso(timezone), [timezone]);
  const tomorrow = useMemo(() => tomorrowIso(timezone), [timezone]);
  return { today, tomorrow, timezone };
}
